import { Component, OnInit } from '@angular/core';
import { MENU_ITEMS } from './news-menu';

@Component({
  selector: 'ngx-news',
  template: `<ngx-one-column-news-layout>
              <nb-menu [items]="NbMenuItems"></nb-menu>
               <router-outlet></router-outlet>
            </ngx-one-column-news-layout>`,
  styleUrls: ['./news.component.scss']
})
export class NewsLayoutComponent implements OnInit {
    
  NbMenuItems = MENU_ITEMS;

  constructor() { }

  ngOnInit(): void {}

}
